export enum BadgeColor {
  GREEN = 'GREEN',
  RED = 'RED',
  GREY = 'GREY',
  BLUE = 'BLUE',
  YELLOW = 'YELLOW',
}

export enum BadgeSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}
